import { DataTypeState, EntityType, PrimitiveTypes } from '@elyx-code/project-logic-tree';

export function getLiteralValueNameFromDataType(dataType: DataTypeState | null): PrimitiveTypes {
  if (!dataType) {
    return PrimitiveTypes.Untyped;
  }

  if (dataType.entity) {
		if (dataType.entity.type === EntityType.DefinitionEntity) {
			if (dataType.asType) {
				return PrimitiveTypes.EntityTemplate;
			}

			return PrimitiveTypes.Untyped;
		} else if (dataType.entity.type === EntityType.PrimitiveEntity) {
			if (dataType.asType) {
				return PrimitiveTypes.EntityTemplate;
			}

			return dataType.entity.name;
		} else if (dataType.entity.type === EntityType.ActionDescriptor) {
			return PrimitiveTypes.ActionDescriptor;
		} else if (dataType.entity.type === EntityType.BuiltInBaseEntity) {
			if (dataType.asType) {
				return PrimitiveTypes.EntityTemplate;
			}

			return PrimitiveTypes.Untyped;
		}
	}

  return PrimitiveTypes.Untyped;
}
